import { apiRequest, buildURL } from './commons/CommonService.Functions';
import { ContractStageItemViewModel } from '../models/Entities/Contracts/ContractStageItemViewModel';

const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'contracts/stages';

export interface CreateContractStageItemCommand {
    contractStageId?: number;
    ermProtocolVisitId?: number;
    emrProtocolVisitName?: string;
}

export interface UpdateContractStageItemCommand {
    id?: number;
    contractStageId?: number;
    ermProtocolVisitId?: number;
    emrProtocolVisitName?: string;
}

// Get all stage items by contract stage id
export const GetContractStageItems = async (token: string, contractStageId: number): Promise<ContractStageItemViewModel[]> => {
    const requestURL = buildURL(BaseURL, contractStageId, 'items');
    return apiRequest<ContractStageItemViewModel[]>(requestURL, token, 'GetContractStageItems', { method: 'GET' });
};

// Get stage item by id
export const GetContractStageItemById = async (token: string, contractStageId: number, stageItemId: number): Promise<ContractStageItemViewModel> => {
    const requestURL = buildURL(BaseURL, contractStageId, 'items', stageItemId);
    return apiRequest<ContractStageItemViewModel>(requestURL, token, 'GetContractStageItemById', { method: 'GET' });
};

// Add contract stage item
export const AddContractStageItem = async (
    token: string,
    contractStageId: number,
    data: CreateContractStageItemCommand
): Promise<ContractStageItemViewModel> => {
    const requestURL = buildURL(BaseURL, contractStageId, 'items');
    return apiRequest<ContractStageItemViewModel>(requestURL, token, 'AddContractStageItem', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

// Update contract stage item
export const UpdateContractStageItem = async (
    token: string,
    contractStageId: number,
    stageItemId: number,
    data: UpdateContractStageItemCommand
): Promise<ContractStageItemViewModel> => {
    const requestURL = buildURL(BaseURL, contractStageId, 'items', stageItemId);
    return apiRequest<ContractStageItemViewModel>(requestURL, token, 'UpdateContractStageItem', {
        method: 'PUT',
        body: JSON.stringify(data)
    });
};

// Delete contract stage item
export const DeleteContractStageItem = async (token: string, contractStageId: number, stageItemId: number): Promise<void> => {
    const requestURL = buildURL(BaseURL, contractStageId, 'items', stageItemId);
    return apiRequest<void>(requestURL, token, 'DeleteContractStageItem', { method: 'DELETE' });
};
